import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "./adminApi";

const Ctx = createContext(null);

const isPanelPath = (p) => p.startsWith("/painel") || p.startsWith("/admin");

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=checking, false=guest, object=logged in
  const checkedRef = useRef(false);
  const location = useLocation();

  useEffect(() => {
    // Só verificar sessão quando o utilizador entra numa rota do painel.
    // Evita chamar /auth/me em todas as páginas públicas (o que gerava
    // 401 ruidoso no console para visitantes anónimos).
    if (!isPanelPath(location.pathname)) {
      setUser((prev) => (prev === undefined ? false : prev));
      return;
    }
    if (checkedRef.current) return;
    checkedRef.current = true;
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, [location.pathname]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    checkedRef.current = true;
    setUser(data);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    checkedRef.current = false;
    setUser(false);
  };

  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
};

export const useAdminAuth = () => useContext(Ctx);
